/**
 * v-click-outside="handlerFn"
 *
 * Calls `handlerFn` whenever a click happens outside the bound element -
 * useful for closing dropdowns/menus like DownloadMenu when the person
 * clicks elsewhere on the page.
 */
export const clickOutside = {
  mounted(el, binding) {
    el.__clickOutsideHandler__ = (event) => {
      if (el.contains(event.target)) return // click was inside - ignore
      if (typeof binding.value === 'function') {
        binding.value(event)
      }
    }
    document.addEventListener('click', el.__clickOutsideHandler__, true)
  },

  unmounted(el) {
    document.removeEventListener('click', el.__clickOutsideHandler__, true)
    delete el.__clickOutsideHandler__
  },
}